export default __webpack_public_path__ + "static/media/brand-2026.4df66747.png";